import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export const BranchFormYup = yupResolver<any>(
  yup
    .object({
      name: yup.string().min(2).required(),
      address: yup.string().optional(),
      enabled: yup.boolean().required(),
    })
    .required(),
);

